import OrganizationTree from '@/models/OrganizationTree'
import CollectionTransformer from '@/transformers/CollectionTransformer'
import OrganizationDeviceTreeTransformer from '@/transformers/OrganizationDeviceTreeTransformer'
import OrganizationFleetTreeTransformer from '@/transformers/OrganizationFleetTreeTransformer'

export default class OrganizationTreeTransformer {
    constructor (
        collectionTransformer = new CollectionTransformer(),
        organizationDeviceTreeTransformer = new OrganizationDeviceTreeTransformer(),
        organizationFleetTreeTransformer = new OrganizationFleetTreeTransformer()
    ) {
        this.collectionTransformer = collectionTransformer
        this.organizationDeviceTreeTransformer = organizationDeviceTreeTransformer
        this.organizationFleetTreeTransformer = organizationFleetTreeTransformer
    }

    transform (data, parent) {
        let organization = new OrganizationTree(
            data.parentId,
            data.id,
            data.level,
            data.name,
            data.organizationCounter || 0,
            data.fleetsCounter || 0,
            data.devicesCounter || 0,
            data.vehicleCounter || 0
        )

        organization.setParent(data.parent || null)

        let organizations = []
        data.organizations.forEach((organizationItem) => {
            let organizationTransformed = this.transform(organizationItem, organization)
            organizationTransformed.setParent(organization)
            organizations.push(organizationTransformed)
        })
        organization.setOrganizations(organizations)

        let fleets = []
        data.fleets.forEach((fleetItem) => {
            let fleetTransformed = this.organizationFleetTreeTransformer.transform(fleetItem, organization)
            fleetTransformed.setParent(organization)
            fleets.push(fleetTransformed)
        })
        organization.setFleets(fleets)

        let devices = []
        data.devices.forEach((deviceItem) => {
            let deviceTransformed = this.organizationDeviceTreeTransformer.transform(deviceItem, organization)
            deviceTransformed.setParent(organization)
            devices.push(deviceTransformed)
        })
        organization.setDevices(devices)

        return organization
    }
}
